import { styled, css } from 'styled-components';

const infiniteSliderCss = css`
  .swiper-wrapper {
    transition-timing-function: linear;
  }
  .swiper-slide {
    width: unset;
  }
`;

export const Wrapper = styled.div.attrs(({ className }) => ({
  className,
}))<{
  $bulletsInImage: boolean;
  $swiperPaginationFlexDir: string;
  $infiniteSlider: boolean;
}>`
  overflow: hidden;

  .swiper {
    overflow: visible;
  }

  .swiper-horizontal {
    display: flex;
    flex-direction: ${(props) => props.$swiperPaginationFlexDir};
  }

  .swiper-pagination {
    position: relative;
    bottom: 0 !important;
  }

  .swiper-pagination-bullet {
    background-color: var(--color-numa-black--300);
  }

  .swiper-pagination-bullet-active {
    background-color: var(--color-numa-black--400);
  }

  .swiper-slide {
    height: auto;
  }

  ${({ $bulletsInImage }) =>
    $bulletsInImage &&
    css`
      .swiper-pagination {
        position: absolute;
      }

      .swiper-pagination-bullets {
        align-self: center;
        background: linear-gradient(to bottom, rgba(33, 35, 34, 0) 10%, rgba(33, 35, 34, 0.6));
        padding-block-end: 1em;
        padding-block-start: 2em;

        span {
          background-color: white;
        }
      }
    `}

  ${({ $infiniteSlider }) => $infiniteSlider && infiniteSliderCss}
`;
